import { render, staticRenderFns } from "./VirtualScroll.vue?vue&type=template&id=0b058bae&scoped=true"
import script from "./VirtualScroll.vue?vue&type=script&lang=ts"
export * from "./VirtualScroll.vue?vue&type=script&lang=ts"
import style0 from "./VirtualScroll.vue?vue&type=style&index=0&id=0b058bae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b058bae",
  null
  
)

export default component.exports